export default "__VITE_ASSET__BdrM1QxC__"